const style = () => ({
    spacing: {
        padding: '15px 0',
        whiteSpace: 'pre-line',
        wordBreak: 'break-all',
    },
    radioButton: {
        fontSize: '14px',
    },
    currencyInput: {
        '& input': {
            padding: '9px',
            width: '333px',

            '&::-webkit-inner-spin-button': {
                opacity: 1, // Always show spin buttons on Chrome
            },
        },
    },
    numberInput: {
        width: '150px',
    },
    price: {
        '&:after': {
            content: '"円"',
            transform: 'translateX(calc(100% + 10px))',
        },
    },
});

export default style;
